import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

export const GalleryPage = ({ fetchGallery, isLoading, gallery }) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [active, setActive] = useState("Gallery");

    const allItems = [
        { src: `${process.env.PUBLIC_URL}/assets/images/bhawani.png` },
        { src: `${process.env.PUBLIC_URL}/assets/images/image1.png` },
        { src: `${process.env.PUBLIC_URL}/assets/images/image2.jpg` },
        { src: `${process.env.PUBLIC_URL}/assets/images/image6.png` },





    ];

    return (
        <>
            <div className="full-row bg-light overlay-dark py-5"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover" }}>
                <div className="container">
                    <div className="row text-center text-white">
                        <div className="col-12">
                            <h3 className="mb-2 text-white font-weight-bold">Gallery</h3>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center bg-transparent">
                                    <li className="breadcrumb-item">
                                        <a href="#" className="text-white">Home</a>
                                    </li>
                                    <li className="breadcrumb-item active text-white" aria-current="page">Gallery</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div style={{ display: "flex", justifyContent: "center", gap: "30px", marginTop: "20px" }}>
                    <div ><span style={{ cursor: "pointer", fontSize: "20px", fontWeight: 700, backgroundColor: active == "Gallery" ? "#dadada" : "transparent", border: "1px solid #dadada", padding: "7px 15px" }} onClick={() => setActive("Gallery")}>Gallery</span></div>
                    <div ><span style={{ cursor: "pointer", fontSize: "20px", fontWeight: 700, backgroundColor: active == "Events" ? "#dadada" : "transparent", border: "1px solid #dadada", padding: "7px 15px" }} onClick={() => setActive("Events")}>Events</span></div>
                    <div ><span style={{ cursor: "pointer", fontSize: "20px", fontWeight: 700, backgroundColor: active == "Videos" ? "#dadada" : "transparent", border: "1px solid #dadada", padding: "7px 15px" }} onClick={() => setActive("Videos")}>Videos</span></div>
                </div>
                {active == "Gallery" && (
                    <div class="row" style={{ marginTop: "30px" }}>
                        {allItems?.map((x, i) => (
                            <div class="col-md-4 col-sm-2 col-xs-12" key={i} style={{ paddingBottom: "30px", cursor: "pointer" }} onClick={() => setOpen(true)}>
                                <img src={`${x?.src}`} width="100%" />
                            </div>
                        ))}
                    </div>
                )}
                {active == "Events" && (
                    <div class="row" style={{ marginTop: "30px" }}>
                        <div style={{ display: "flex", justifyContent: "center", fontSize: "32px", marginBottom: "30px" }}>Result Not found</div>
                    </div>
                )}
                {active == "Videos" && (
                    <div class="row" style={{ marginTop: "30px" }}>
                        <div class="col-md-4 col-sm-2 col-xs-12">
                            <iframe width="100%" height="300" src="https://www.youtube.com/embed/PXUs6O8JAZI?si=AyXTSIb_zgQN2-_S" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div class="col-md-4 col-sm-2 col-xs-12">
                            <iframe width="100%" height="300" src="https://www.youtube.com/embed/qzH6DUeJDGE?si=sPjvKHdN46nYj1t8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div class="col-md-4 col-sm-2 col-xs-12">
                            <iframe width="100%" height="300" src="https://www.youtube.com/embed/n9cKmKF9wfA?si=4dsuWGCEr-2uBR3w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <div class="col-md-4 col-sm-2 col-xs-12">
                            <iframe width="100%" height="300" src="https://www.youtube.com/embed/-SGZJbztMwI?si=gFrFQdwSl8SeeCKv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                    </div>
                )}
            </div>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={allItems}
            />
        </>
    );
};
